module.exports = __webpack_public_path__ + "media/icons/extras--recurring-bb80206c.svg";